import Service from '@/services/Service'
class MeasurementUnitsService extends Service {
  constructor() {
    super('')
    this.resource = 'units-measurement'
  }

  createRequestUrl(query = null) {
    let requestUrl = `${this.resource}?`

    if(query)
      query = this.encodeQueryValues(query);

    if (query && query.codigo)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CODIGO=${query.codigo}`
        : `CODIGO=${query.codigo}`
    if (query && query.fator)
      requestUrl += this.hasParameter(requestUrl)
        ? `&FATOR=${query.fator}`
        : `FATOR=${query.fator}`
    if (query && query.descricao)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DESCRICAO=${query.descricao}`
        : `DESCRICAO=${query.descricao}`

    return requestUrl
  }

  async getMeasurementUnitsAPI(query = null) {
    let requestUrl = this.createRequestUrl(query)
    return await this.getAPI(requestUrl)
  }

  async getMeasurementUnitAPI(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    return await this.getAPI(requestUrl)
  }
}

export default new MeasurementUnitsService()
